//Define tailwind classses for button styles here
export const getButtonStyle = (style) => {
  switch (style) {
    case "primary":
      return "btn-primary";

    case "secondary":
      return "btn-secondary";

    case "tertiary":
      return "btn-tertiary";

    case "gold":
      return "btn-gold";

    case "lime": 
      return "btn-lime";

    default:
      return "btn-primary";
  }
};
